import { defineComponent, toRefs } from "vue";
import props from "./props";
import "./style/table.less";
import { TableCol } from "./type";

export default defineComponent({
  name: "CTable",
  props: { ...props },
  setup(props, { slots }) {
    const { data, columns } = toRefs(props);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getValue = (item: any, prop: string) => {
      const arr = prop.split(".");
      arr.every((key) => {
        item = item[key];
        return !!item;
      });
      return item || "";
    };
    const renderHeader = () => {
      return (
        <div class="c-table-row c-table-header">
          {columns.value?.map((item) => {
            return <div class="c-table-td">{item.title}</div>;
          })}
        </div>
      );
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const renderCell = (item: any, col: TableCol, index: number) => {
      const value = getValue(item, col.prop);
      const cellSlot = slots[col.prop];
      if (cellSlot) {
        return cellSlot({ row: item, value, index });
      } else {
        return value;
      }
    };
    const renderBody = () => {
      return (
        <div class="c-table-body">
          {data.value && data.value.length > 0 ? (
            data.value.map((item, index) => {
              return (
                <div class="c-table-row">
                  {columns.value?.map((col) => {
                    return (
                      <div class="c-table-td">
                        {renderCell(item, col, index)}
                      </div>
                    );
                  })}
                </div>
              );
            })
          ) : (
            <div class="c-table-empty">暂无数据</div>
          )}
        </div>
      );
    };
    return () => (
      <div class="c-table">
        {renderHeader()}
        {renderBody()}
      </div>
    );
  },
});
